import { keepPreviousData } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { UseQueryConfig, UseSuspenseQueryConfig } from 'common/query/types';
import {
  usePersistedApiQuery,
  usePersistedApiSuspenseQuery,
} from 'common/query/usePersistedApiQuery';

import { gatewayApiAgent } from '../api/apiAgents';
import { Country } from '../api-types/director';

async function fetchCountries() {
  const response = await gatewayApiAgent.get<Country[]>('/director/public/v1/countries', {
    params: {},
  });
  return response.data;
}

const COUNTRIES_QUERY_KEY_ROOT = 'countries';

export function useCountriesQuery<TData = Country[]>(
  options?: UseQueryConfig<Country[], AxiosError, TData>,
) {
  return usePersistedApiQuery({
    ...options,
    queryKey: [COUNTRIES_QUERY_KEY_ROOT],
    queryFn: fetchCountries,
    staleTime: 300000,
    placeholderData: keepPreviousData,
  });
}

export function useCountriesSuspenseQuery<TData = Country[]>(
  options?: UseSuspenseQueryConfig<Country[], AxiosError, TData>,
) {
  return usePersistedApiSuspenseQuery({
    ...options,
    queryKey: [COUNTRIES_QUERY_KEY_ROOT],
    queryFn: fetchCountries,
    staleTime: 300000,
  });
}
